import { API_BASE_URL } from '../config';
import { apiFetch } from '../utils/apiFetch';

export interface ApiStatus {
  message: string;
  version: string;
  status: string;
  trading_mode?: 'paper' | 'live';
  paper_trading?: boolean;
  live_trading_enabled?: boolean;
  order_guard?: 'enabled' | 'locked';
}

export async function getApiStatus(): Promise<ApiStatus> {
  const response = await apiFetch(`${API_BASE_URL}/api/status`);
  if (!response.ok) {
    throw new Error(`API 상태 조회 실패: ${response.status}`);
  }
  return response.json();
}
